import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { InputTextarea } from "primereact/inputtextarea";
import { useState } from "react";
import styled from "styled-components";

const MarkAsCheckContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export function MarkAsPaidCheckDialog({
  markViaFinancingOrCashOrCheck,
  showDialog,
  setShowDialog,
}: {
  markViaFinancingOrCashOrCheck: any;
  showDialog: boolean;
  setShowDialog: any;
}) {
  const [notes, setNotes] = useState<string>("");

  const footerComponent = () => {
    return (
      <div>
        <Button
          label="Cancel"
          onClick={() => setShowDialog(false)}
          className="mr-2"
        />
        <Button
          label="Mark as Paid by Check"
          onClick={() => {
            markViaFinancingOrCashOrCheck("Check", notes);
            setShowDialog(false);
            setNotes("");
          }}
        />
      </div>
    );
  };

  return (
    <Dialog
      onHide={() => setShowDialog(false)}
      visible={showDialog}
      header="Confirmation"
      footer={footerComponent}
    >
      <MarkAsCheckContainer>
        <span className="mb-3">
          Are you sure you want to mark as paid via check?
        </span>

        <InputTextarea
          value={notes}
          onChange={(e) => setNotes(e.target.value)}
          rows={2}
          placeholder="Notes"
          className="w-full mt-3"
        />
      </MarkAsCheckContainer>
    </Dialog>
  );
}
